"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultRegularVetDisplaySettings = void 0;
var _radios = require("../../constants/radios");
var defaultRegularVetDisplaySettings = exports.defaultRegularVetDisplaySettings = {
  readonlyMode: false,
  regularVetPanelToggleRadios: {
    name: 'hasRegularVet',
    groupLabel: 'Do you have a regular vet?',
    radioInputs: _radios.SIMPLE_YES_NO,
    validation: {
      required: 'Please choose an option'
    }
  },
  regularVetInput: {
    name: 'regularVet',
    label: 'Your vet',
    labelTooltip: 'Please enter 3 or more characters to search for your vet\'s name. If it is not listed please select unknown Vet.',
    placeholder: 'Start typing to search...',
    validation: {
      required: 'Please enter your vet\'s name.'
    }
  }
};